import type { ConnectorProvider } from "@app/types/data_source";

export interface ConnectorMetadata {
  description: string;
  guideLink: string | null;
}

export const CONNECTOR_METADATA = {
  confluence: {
    description:
      "Grant tailored access to your organization's Confluence shared spaces.",
    guideLink: null,
  },
  notion: {
    description:
      "Authorize granular access to your company's Notion workspace, by top-level pages.",
    guideLink: null,
  },
  google_drive: {
    description:
      "Authorize granular access to your company's Google Drive, by drives and folders. Supported files include GDocs, GSlides, and .txt files. Email us for .pdf indexing.",
    guideLink: null,
  },
  slack: {
    description:
      "Authorize granular access to your Slack workspace on a channel-by-channel basis.",
    guideLink: null,
  },
  github: {
    description:
      "Authorize access to your company's GitHub on a repository-by-repository basis. Azimut can access Issues, Discussions, and Pull Request threads. Code indexing can be controlled on-demand.",
    guideLink: null,
  },
  intercom: {
    description:
      "Authorize granular access to your Intercom workspace. Access your Conversations at the Team level and Help Center Articles at the main Collection level.",
    guideLink: null,
  },
  microsoft: {
    description:
      "Authorize Azimut to access a Microsoft account and index shared documents stored in SharePoint, OneDrive, and Office365.",
    guideLink: null,
  },
  webcrawler: {
    description: "Crawl a website.",
    guideLink: null,
  },
  snowflake: {
    description: "Query a Snowflake database.",
    guideLink: null,
  },
  zendesk: {
    description:
      "Authorize access to Zendesk for indexing tickets from your support center and articles from your help center.",
    guideLink: null,
  },
  bigquery: {
    description: "Query a BigQuery database.",
    guideLink: null,
  },
  salesforce: {
    description:
      "Authorize access to your Salesforce organization, in order to query your Salesforce data from Azimut.",
    guideLink: null,
  },
  gong: {
    description: "Authorize access to Gong for indexing call transcripts.",
    guideLink: null,
  },
} satisfies Partial<Record<ConnectorProvider, ConnectorMetadata>>;

const METADATA_BY_PROVIDER: Partial<
  Record<ConnectorProvider, ConnectorMetadata>
> = CONNECTOR_METADATA;

export function getConnectorMetadata(
  provider: ConnectorProvider
): ConnectorMetadata | undefined {
  return METADATA_BY_PROVIDER[provider];
}
